import { render } from "./PlanStats.vue?vue&type=template&id=18d77c83"
import script from "./PlanStats.vue?vue&type=script&lang=js"
export * from "./PlanStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__